import { render, staticRenderFns } from "./UserAccountGeneral.vue?vue&type=template&id=3ae50bdc&"
import script from "./UserAccountGeneral.vue?vue&type=script&lang=js&"
export * from "./UserAccountGeneral.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports